import type { HttpClient } from '../client';
import type {
  ReportDefRow,
  ReportRunResult,
  ReportSubscribeRow,
  ReportSubscribeUpsert
} from '../types/report';

const BASE = '/report';

/** R14 报表订阅：定义列表 / 订阅维护 / 立即执行。 */
export function createReportApi(http: HttpClient) {
  return {
    defs(): Promise<ReportDefRow[]> {
      return http.request<ReportDefRow[]>({ path: `${BASE}/defs` });
    },

    /** 立即执行报表定义（仅 SQL 类型；CSV 下载请走浏览器直连 `?format=csv`）。 */
    runDef(reportCode: string, paramsJson?: string): Promise<ReportRunResult> {
      return http.request<ReportRunResult>({
        path: `${BASE}/defs/${encodeURIComponent(reportCode)}/run`,
        query: { paramsJson }
      });
    },

    subscriptions(): Promise<ReportSubscribeRow[]> {
      return http.request<ReportSubscribeRow[]>({ path: `${BASE}/subscriptions` });
    },

    saveSubscription(body: ReportSubscribeUpsert): Promise<ReportSubscribeRow> {
      return http.request<ReportSubscribeRow>({ path: `${BASE}/subscriptions`, method: 'POST', body });
    },

    deleteSubscription(id: number | string): Promise<{ id: number | string }> {
      return http.request<{ id: number | string }>({
        path: `${BASE}/subscriptions/${encodeURIComponent(String(id))}`,
        method: 'DELETE'
      });
    },

    runSubscription(id: number | string): Promise<ReportRunResult> {
      return http.request<ReportRunResult>({
        path: `${BASE}/subscriptions/${encodeURIComponent(String(id))}/run`,
        method: 'POST'
      });
    }
  };
}

export type ReportApi = ReturnType<typeof createReportApi>;
